export const reasonArray = [
  { id: 1, text: "Preparing for an upcoming session" },
  { id: 2, text: "Demonstrating for colleagues" },
  { id: 3, text: "Getting more familiar with the game" },
  { id: 4, text: "Other" },
];
